"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.useControlled = useControlled;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// https://github.com/mui-org/material-ui/blob/617674a1ff24c5da981a63ef6c5290f53ed1e919/packages/material-ui/src/utils/useControlled.js
function useControlled(_ref /*:: */) {
  var valueProp = _ref /*:: */.value,
    defaultValue = _ref /*:: */.defaultValue;
  var _React$useRef = React.useRef(typeof valueProp !== 'undefined'),
    isControlled = _React$useRef.current;
  var _React$useState = React.useState(defaultValue),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    valueState = _React$useState2[0],
    setValue = _React$useState2[1];
  var setValueIfUncontrolled = React.useCallback(function (newValue /*: mixed*/) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, [isControlled]);
  var value = isControlled ? valueProp : valueState;
  return [value, setValueIfUncontrolled];
}
var _default = exports.default = useControlled;
//# sourceMappingURL=useControlled.js.map